import React from 'react'

import styles from './Dot.module.css'

export default () => (
  <div className={styles.container}>
    <div className={styles.dot}/>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Dot.js